// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contact":"_1887Y4","listWrapper":"_2PGzdl","listItem":"_2Gf9Db","link":"jhF1NN","phoneContainer":"_3cerFz","heading":"D2XSsU"};